import './stressfreeevents/style';
import FormStructure from './stressfreeevents/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js